import { render, staticRenderFns } from "./ModalShowImage.vue?vue&type=template&id=468d7ae8&scoped=true&lang=pug"
import script from "./ModalShowImage.vue?vue&type=script&lang=ts"
export * from "./ModalShowImage.vue?vue&type=script&lang=ts"
import style0 from "./ModalShowImage.vue?vue&type=style&index=0&id=468d7ae8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468d7ae8",
  null
  
)

export default component.exports